module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }